import PublicAnalytics from '@public/images/fintech-and-banking/public-analytics.png'

import TextWithImageGoingOffScreen from '@/components/TextWithImageGoingOffScreen/TextWithImageGoingOffScreen'

export default function AuditReadyFintech() {
    return (
        <TextWithImageGoingOffScreen
            title={`Out-of-the-box emission reporting`}
            paragraph={`Grow monthly active users with Lune’s decision-useful analytics page generated for each of your customers. Accelerate their decarbonisation goals by pinpointing emission hotspots within their business spend.`}
            img={PublicAnalytics}
        />
    )
}
